/* rh-size-pills: sorts and row-fits the size pills rendered by
   snippets/rh-size-pills.liquid. Ported from the Snagged & Bagged build.

   - Max RH_MAX_ROWS rows per card. Overflow pills are hidden (class, not inline
     style) and a dashed "+N" pill linking to the product page is appended.
   - Measured, not estimated: pill widths are read after paint, so it adapts to
     any card width without breakpoints.
   - Scheduling is setTimeout based on purpose. requestAnimationFrame never fires
     in background tabs, which left pills overflowing until the tab was focused.
   - A MutationObserver re-fits after Dawn's facet/sort re-renders, which replace
     the whole product grid. rhFitting guards against reacting to our own edits.
*/
(function () {
  if (window.__rhSizePills) return;
  window.__rhSizePills = true;

  var RH_MAX_ROWS = 2;
  var RH_MORE_W = 37;   // reserved width for the "+N" pill on the last row
  var RH_GAP = 4;       // must match the CSS gap
  var RH_PAD_X = 12;    // must match the CSS horizontal padding (6px * 2)

  var ALPHA = { xxxs: 0, xxs: 1, xs: 2, s: 3, m: 4, l: 5, xl: 6, xxl: 7, xxxl: 8, xxxxl: 9, xxxxxl: 10 };
  var MAP = {
    '3xs': 'xxxs', '2xs': 'xxs', '2xl': 'xxl', '3xl': 'xxxl', '4xl': 'xxxxl', '5xl': 'xxxxxl',
    'x-small': 'xs', 'xsmall': 'xs', 'small': 's', 'medium': 'm', 'large': 'l',
    'x-large': 'xl', 'xlarge': 'xl', 'xx-large': 'xxl', 'xxlarge': 'xxl', 'xxx-large': 'xxxl'
  };

  function rank(label) {
    var k = String(label || '').trim().toLowerCase();
    k = MAP[k] || k;
    if (Object.prototype.hasOwnProperty.call(ALPHA, k)) return [0, ALPHA[k], k];
    if (/^\d/.test(k)) {
      var n = parseFloat(k);
      if (!isNaN(n)) return [1, n, k];
    }
    return [2, 0, k];
  }

  function cmp(a, b) {
    var ra = rank(a.textContent), rb = rank(b.textContent);
    if (ra[0] !== rb[0]) return ra[0] - rb[0];
    if (ra[0] !== 2 && ra[1] !== rb[1]) return ra[1] - rb[1];
    return ra[2] < rb[2] ? -1 : ra[2] > rb[2] ? 1 : 0;
  }

  // How many pills fit in `rows` rows of `avail` px, keeping `reserve` px free
  // at the end of the last row.
  function pack(widths, avail, rows, reserve) {
    var row = 1, x = 0, count = 0;
    for (var i = 0; i < widths.length; i++) {
      var w = widths[i];
      var limit = row === rows ? avail - reserve : avail;
      var need = x === 0 ? w : x + RH_GAP + w;
      if (need <= limit) {
        x = need;
        count++;
      } else {
        if (row === rows) break;
        row++;
        limit = row === rows ? avail - reserve : avail;
        if (w > limit) break;
        x = w;
        count++;
      }
    }
    return count;
  }

  function fit(box) {
    if (!box.__rhSorted) {
      var sortable = [].slice.call(box.querySelectorAll('.rh-size-pill:not(.rh-size-pill--more)'));
      sortable.sort(cmp);
      for (var s = 0; s < sortable.length; s++) box.appendChild(sortable[s]);
      box.__rhSorted = true;
    }
    var more = box.querySelector('.rh-size-pill--more');
    if (more) more.parentNode.removeChild(more);

    var pills = [].slice.call(box.querySelectorAll('.rh-size-pill'));
    for (var i = 0; i < pills.length; i++) pills[i].classList.remove('rh-size-pill--hidden');
    if (!pills.length) return;

    var avail = box.clientWidth - RH_PAD_X;
    if (avail <= 0) return;

    var widths = [];
    for (var j = 0; j < pills.length; j++) widths.push(pills[j].offsetWidth);

    if (pack(widths, avail, RH_MAX_ROWS, 0) >= pills.length) return;

    var n = pack(widths, avail, RH_MAX_ROWS, RH_MORE_W);
    for (var k = n; k < pills.length; k++) pills[k].classList.add('rh-size-pill--hidden');

    var extra = pills.length - n;
    var a = document.createElement('a');
    a.className = 'rh-size-pill rh-size-pill--more';
    a.href = box.getAttribute('data-url') || '#';
    a.textContent = '+' + extra;
    a.setAttribute('aria-label', extra + ' more sizes');
    box.appendChild(a);
  }

  var rhFitting = false;
  var timer = null;

  function fitAll() {
    rhFitting = true;
    try {
      var boxes = document.querySelectorAll('.rh-sizes');
      for (var i = 0; i < boxes.length; i++) fit(boxes[i]);
    } finally {
      // let the observer skip the mutations we just made
      setTimeout(function () { rhFitting = false; }, 0);
    }
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(fitAll, delay == null ? 60 : delay);
  }

  function start() {
    schedule(0);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { schedule(0); });
    }
    window.addEventListener('resize', function () { schedule(120); });
    window.addEventListener('pageshow', function () { schedule(0); });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (records) {
        if (rhFitting) return;
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          if (t && t.classList && t.classList.contains('rh-sizes')) continue;
          schedule();
          return;
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
